import MarkerStore from '../stores/marker-store';

export default {

  getMarkerLabel(markerId) {
    const marker = MarkerStore.get(markerId);
    return marker ? marker.label : "";
  }

};
